module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image3.06187e58.jpg";